import './App.css';
import Head from './components/Head';
import Body from './components/Body';
// import About from './components/About'; // Import About component
import Skills from './components/Skills'; // Import Skills component
import Contact from './components/ContactUs'; // Import Contact component
import CodingProfiles from './components/CodingProfiles';
import Footer from './components/Footer'; // Import Footer component
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div>
        <Head />
        <Routes>
          <Route exact path='/' element={<Body />} />
          {/* <Route path='/about' element={<About />} /> */}
          <Route path='/skills' element={<Skills />} />
          <Route path='/codingprofiles' element={<CodingProfiles />} />
          <Route path='/contact' element={<Contact />} />
          {/* Add routes for other pages as needed */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
